// extracted by mini-css-extract-plugin
export default {"node":"styles_node__u9V3C","content":"styles_content__eHNRv","text":"styles_text__qfRrV","buttonsContainer":"styles_buttonsContainer__kutH-","button":"styles_button__DLLL7"};